<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'energy_savings' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">

    <ng-container class="contentDiv">

      <div class="form-container">
        <!-- Winter -->
        <div *ngIf="showWinterFields">
          <div class="category-header"> {{'winter' | translate}} </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_DURATION_HEATING_SEASON' | translate}} ({{'HEADER_DAYS' | translate}})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterHeatSeason" (ionChange)="onFieldChange()"
              min="1" max="365">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_AVG_EXTERNAL_TEMP_HEATING_SEASON' | translate}} ({{ tempUnitSymbol }})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterExternalTemp"
              (ionChange)="onFieldChange()">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_AVG_INTERNAL_TEMP_HEATING_SEASON' | translate}} ({{ tempUnitSymbol }})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterInternalTemp"
              (ionChange)="onFieldChange()">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_FUELS' | translate }}</label>
            <ion-select [(ngModel)]="winterFuelType" interface="popover" (ionChange)="onWinterFuelChange()"
              class="styled-select" cssClass="select-popover">
              <ion-select-option *ngFor="let fuel of fuelTypes" [value]="fuel.value">
                {{ fuel.label | translate }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_CALORIFIC_VALUE' | translate}} (kWh/Ltr.)</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterCalorificValue"
              (ionChange)="onFieldChange()" step="0.01">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'COSTS_LITER' | translate}}</label>
            <div class="select-row">
              <ion-input class="bordered-input" type="number" [(ngModel)]="winterHeatingCost"
                (ionChange)="onFieldChange()" step="0.01">
              </ion-input>
              <ion-select [(ngModel)]="winterCurrency" (ionChange)="onFieldChange()" interface="popover"
                class="currency-select">
                <ion-select-option *ngFor="let curr of currencies" [value]="curr">
                  {{ curr }}
                </ion-select-option>
              </ion-select>
            </div>
          </div>
          <div class="select-group">
            <label class="select-label">{{'COST_INCREASE_WE_CE' | translate}} (%)</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterCostDelta" (ionChange)="onFieldChange()"
              min="0" max="100" step="0.1">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_EFFICIENCY_HEATING_SYSTEM' | translate}} (%)</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="winterEfficiency" (ionChange)="onFieldChange()"
              min="1" max="100">
            </ion-input>
          </div>
        </div>
        <!-- Summer -->
        <div *ngIf="showSummerFields">
          <div class="category-header"> {{'summer' | translate}} </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_DURATION_COOLING_SEASON' | translate}} ({{'HEADER_DAYS' | translate}})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="summerCoolSeason" (ionChange)="onFieldChange()"
              min="1" max="365">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_AVG_EXTERNAL_TEMP_COOLING_SEASON' | translate}} ({{ tempUnitSymbol }})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="summerExternalTemp"
              (ionChange)="onFieldChange()">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_AVG_INTERNAL_TEMP_COOLING_SEASON' | translate}} ({{ tempUnitSymbol }})</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="summerInternalTemp"
              (ionChange)="onFieldChange()">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{ 'HEADER_POWER_TYPE' | translate }}</label>
            <ion-select [(ngModel)]="summerPowerType" (ionChange)="onFieldChange()" interface="popover"
              class="styled-select" cssClass="select-popover">
              <ion-select-option *ngFor="let power of powerTypes" [value]="power.value">
                {{ power.label | translate }}
              </ion-select-option>
            </ion-select>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_ELECTRICAL_COSTS' | translate}}</label>
            <div class="select-row">
              <ion-input class="bordered-input" type="number" [(ngModel)]="summerElectricalCost"
                (ionChange)="onFieldChange()" step="0.01">
              </ion-input>
              <ion-select [(ngModel)]="summerCurrency" (ionChange)="onFieldChange()" interface="popover"
                class="currency-select">
                <ion-select-option *ngFor="let curr of currencies" [value]="curr">
                  {{ curr }}
                </ion-select-option>
              </ion-select>
            </div>
          </div>
          <!-- with HEADER_ELECTRICAL_COSTS in same line i need select dropdown to select currency (by default EUR should selected) -->
          <div class="select-group">
            <label class="select-label">{{'COST_INCREASE_WE_CE' | translate}} (%)</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="summerCostDelta" (ionChange)="onFieldChange()"
              min="0" max="100" step="0.1">
            </ion-input>
          </div>
          <div class="select-group">
            <label class="select-label">{{'HEADER_EFFICIENCY_COOLING_SYSTEM' | translate}} (%)</label>
            <ion-input class="bordered-input" type="number" [(ngModel)]="summerEfficiency" (ionChange)="onFieldChange()"
              min="1" max="100">
            </ion-input>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" [disabled]="!isFormValid" expand="block">
      {{'validate' | translate}}
    </ion-button>
  </div>
</ion-footer>